import React from "react";
import { useRenderTemplateWithCollections } from "../MacroBindingContext";

export interface MacroSignatureBlockProps {
  closing: string;
  name: string;
  title?: string;
}

const MacroSignatureBlock = {
  label: "Signature",
  llmDescription: `A signature block for the end of email content.
- 'closing' (string): The closing phrase (e.g., "Healthy regards,", "Best wishes,")
- 'name' (string): The signer's name
- 'title' (string, optional): The signer's title or role
- Supports {{variable}} placeholders in all fields
- Renders with proper line breaks for email format`,
  fields: {
    closing: {
      type: "text" as const,
      label: "Closing Phrase",
    },
    name: {
      type: "text" as const,
      label: "Name",
    },
    title: {
      type: "text" as const,
      label: "Title (optional)",
    },
  },
  defaultProps: {
    closing: "Healthy regards,",
    name: "Liam",
    title: "",
  },
  render: (props: MacroSignatureBlockProps) => {
    const render = useRenderTemplateWithCollections();
    const renderedClosing = render(props.closing);
    const renderedName = render(props.name);
    const renderedTitle = props.title ? render(props.title) : "";

    return (
      <p>
        {renderedClosing}
        <br />
        <br />
        {renderedName}
        {renderedTitle && (
          <>
            <br />
            <em>{renderedTitle}</em>
          </>
        )}
      </p>
    );
  },
};

export default MacroSignatureBlock;
